module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mdigurp3-97ecb53f814747d45d153e7172fbdb88.jpg";